"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnsPublicApiClient = void 0;
const AbstractReturnsClient_1 = require("./AbstractReturnsClient");
const network_utils_1 = require("@deliverr/network-utils");
class ReturnsPublicApiClient extends AbstractReturnsClient_1.AbstractReturnsClient {
    constructor(config) {
        super(config);
        this.loadReturns = async (loadPageFnArgs) => {
            const params = {
                ...loadPageFnArgs.queryParams,
                direction: loadPageFnArgs.direction,
                numEntries: loadPageFnArgs.numEntries,
                cursor: loadPageFnArgs.cursor,
            };
            const res = await this.axios.request({
                url: "/v1/public-api/orders",
                method: "GET",
                headers: loadPageFnArgs.headers,
                params,
            });
            return res.data.value;
        };
    }
    async createOrder(returnOrderRequest, sellerId, callerId) {
        return await this.axios.request({
            url: "/v1/public-api/orders",
            method: "POST",
            headers: this.getReturnsPublicApiHeaders(sellerId, callerId),
            data: returnOrderRequest,
        });
    }
    async getReturns(request) {
        const { cursor, direction = "forward", limit } = request.paging ?? {};
        const queryParams = {
            rma: request.rma,
            status: request.status,
            trackingCode: request.trackingCode,
            externalReturnId: request.externalReturnId,
        };
        const headers = this.getReturnsPublicApiHeaders(request.sellerId);
        const pageArgs = (0, network_utils_1.getPageArgs)(cursor, limit, direction);
        return await (0, network_utils_1.getPage)(this.loadReturns, queryParams, headers, pageArgs);
    }
    async getOrder(returnId, sellerId) {
        return await this.axios.request({
            url: `/v1/public-api/orders/${returnId}`,
            method: "GET",
            headers: this.getReturnsPublicApiHeaders(sellerId),
        });
    }
    async cancelOrder(returnId, sellerId) {
        return await this.axios.request({
            url: `/v1/public-api/orders/${returnId}/cancel`,
            method: "PUT",
            headers: this.getReturnsPublicApiHeaders(sellerId),
        });
    }
    getReturnsPublicApiHeaders(sellerId, callerId) {
        const headers = {
            "x-caller-id": "sfn",
        };
        if (sellerId) {
            headers["x-seller-id"] = sellerId;
        }
        if (callerId) {
            headers["x-caller-id"] = callerId;
        }
        return headers;
    }
}
exports.ReturnsPublicApiClient = ReturnsPublicApiClient;
//# sourceMappingURL=ReturnsPublicApiClient.js.map